import React from "react";
import { Checkbox, Col, Form, Input, InputNumber, Row, Select, Flex } from "antd";

interface PrincipalFieldsProps {
  mode: "users" | "admins";
  domainOptions: Array<{ label: string; value: string }>;
  backendRoleOptions: Array<{ label: string; value: string }>;
}

export const PrincipalFields: React.FC<PrincipalFieldsProps> = ({
  mode,
  domainOptions,
  backendRoleOptions,
}) => (
  <Row gutter={24}>
    <Col span={12}>
      <Flex vertical gap="small" style={{ width: "100%" }}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input size="large" placeholder="Enter full name" />
        </Form.Item>
        <Form.Item label="Login" name="login" rules={[{ required: true }]}>
          <Input size="large" placeholder="Enter username" />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input size="large" placeholder="Enter email address" />
        </Form.Item>
        <Form.Item label="Phone" name="phone">
          <Input size="large" placeholder="Enter phone number" />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input.Password size="large" placeholder="Enter password (optional for edit)" />
        </Form.Item>
      </Flex>
    </Col>

    <Col span={12}>
      <Flex vertical gap="small" style={{ width: "100%" }}>
        {mode === "admins" && (
          <>
            <Form.Item label="Role" name="roleId">
              <Select allowClear placeholder="Select backend role" options={backendRoleOptions} />
            </Form.Item>
            <Form.Item label="Level" name="level">
              <InputNumber min={1} max={10} style={{ width: "100%" }} placeholder="Access level" />
            </Form.Item>
            <Form.Item name="readonly" valuePropName="checked" style={{ marginBottom: 0 }}>
              <Checkbox>Readonly Access</Checkbox>
            </Form.Item>
          </>
        )}
        <Form.Item label="System Domains" name="systemIds">
          <Checkbox.Group style={{ width: "100%" }}>
            <Row gutter={[8, 8]}>
              {domainOptions.map((option) => (
                <Col span={12} key={option.value}>
                  <Checkbox value={option.value}>{option.label}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Flex>
    </Col>
  </Row>

);
